import React, { lazy, Suspense, memo } from 'react';
import PropTypes from 'prop-types';

export const ICON_NAMES = {
    ACHIEVEMENTS: 'icons/Achievements',
    ARROW_RIGHT: 'icons/ArrowRight',
    CLOSE: 'icons/Close',
    CLEAR: 'icons/Clear',
    CARET_DOWN: 'icons/CaretDown',
    CARET_RIGHT: 'icons/CaretRight',
    CARET_LEFT: 'icons/CaretLeft',
    CARESPECIALTIES: 'icons/CareSpecialties',
    CROSS_DOUBLE: 'icons/CrossDouble',
    CONVERSATIONS: 'icons/Conversations',
    CLOSE_SOLID: 'icons/CloseSolid',
    EDUCATION: 'icons/Education',
    EXTERNAL_LINK: 'icons/ExternalLink',
    FACEBOOK: 'icons/Facebook',
    FILTER: 'icons/Filter',
    FV_LOGO: 'icons/FVLogo',
    FV_LOGO_MOBILE: 'icons/FVLogoMobile',
    FIND_LOCATION: 'icons/Location',
    FIND_PROVIDER: 'icons/FindProvider',
    HAMBURGER: 'icons/HamburgerMenu',
    HorizontalTabArrow: 'icons/HorizontalTabArrow',
    HOSPITAL: 'icons/Hospital',
    INSTAGRAM: 'icons/Instagram',
    INSURANCE: 'icons/Insurance',
    LANGUAGE: 'icons/Language',
    LIST: 'icons/List',
    LGBTQCOLOURED: 'icons/LGBTQColoured',
    LOCATION_PIN: 'icons/LocationPinSharp',
    MAP: 'icons/Map',
    NEXT_BTN: 'icons/NextBtn',
    SPEECH_BUBBLE_DOTS: 'icons/SpeechBubbleDots',
    PHONE: 'icons/Phone',
    PREV_BTN: 'icons/PrevBtn',
    PROFILE: 'icons/Profile',
    PROFILE_PLUS: 'icons/ProfilePlus',
    PROFILE_MINUS: 'icons/ProfileMinus',
    PEDIATRIC: 'icons/Pediatric',
    PROVIDERMALEPLACEHOLDER: 'icons/ProviderMalePlaceholder',
    PROVIDERFEMALEPLACEHOLDER: 'icons/ProviderFemalePlaceholder',
    PROVIDEROTHERPLACEHOLDER: 'icons/ProviderOtherPlaceholder',
    LINKEDIN: 'icons/LinkedIn',
    TICK: 'icons/Tick',
    TWITTER: 'icons/Twitter',
    YOUTUBE: 'icons/YouTube',
};

const Icon = (props) => {
    const {
        fill,
        name,
        focusable,
        'aria-label': ariaLabel,
        'aria-hidden': ariaHidden,
        role,
        className,
    } = props;

    if (name) {
        const IconComp = lazy(() =>
            import(/* webpackChunkName: "[request]" */ `./${name}`)
        );

        return (
            <Suspense fallback="">
                <IconComp
                    fill={fill}
                    focusable={focusable}
                    aria-label={ariaLabel}
                    aria-hidden={ariaHidden}
                    role={role}
                    className={className}
                />
            </Suspense>
        );
    }

    return null;
};

Icon.propTypes = {
    fill: PropTypes.string,
    name: PropTypes.string.isRequired,
    focusable: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    'aria-label': PropTypes.string,
    'aria-hidden': PropTypes.string,
    role: PropTypes.string,
    className: PropTypes.string,
};

Icon.defaultProps = {
    fill: 'currentColor',
    focusable: false,
    'aria-label': null,
    'aria-hidden': 'true',
    role: null,
    className: null,
};

const IconMemo = memo(Icon);

export default IconMemo;
